export const TOUR_SHOWN_KEY_PREFIX = 'ph_product_tour_shown_'
export const TOUR_COMPLETED_KEY_PREFIX = 'ph_product_tour_completed_'
export const TOUR_DISMISSED_KEY_PREFIX = 'ph_product_tour_dismissed_'
export const ACTIVE_TOUR_SESSION_KEY = 'ph_active_product_tour'
export const LAST_SEEN_TOUR_DATE_KEY_PREFIX = 'ph_last_seen_tour_date_'
